<script>
import MglGeocoderControl from "vue-mapbox-geocoder";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";

/**
 * Pass `mapboxgl` to the geocoder constructor. Without it,
 * @mapbox/mapbox-gl-geocoder logs "No mapboxgl detected in options. Map
 * markers are disabled." every time the map mounts and silently disables the
 * geocoder result marker. `this.mapbox` is the mapbox-gl module provided by
 * the parent <mgl-map>.
 */
MglGeocoderControl.created = function () {
    this.control = null;
    if (this.accessToken && !this.mapbox.accessToken) {
        this.mapbox.accessToken = this.accessToken;
    }
    this.control = new MapboxGeocoder({
        ...this.$props,
        mapboxgl: this.mapbox,
    });
    this.control.on("results", this.$_updateInput);
    this.$_deferredMount();
};

export default {
    name: "CustomMglGeocoderControl",
    extends: MglGeocoderControl,
};
</script>
